import { useEffect, useState } from "react";
import React from "react";
import { isAndroid, isIOS } from "react-device-detect";
import { Box, Typography, Paper, Stepper, Step, StepLabel, StepContent } from '@mui/material';

export default function DetectPlatform(props) {
  const [isandroid, setIsandroid] = useState(false);
  const [isios, setIsios] = useState(false);
    
  useEffect(() => {
    if (isAndroid) {
      setIsandroid(true);
    } else if (isIOS) {
      setIsios(true);
    }
  }, []);
  
  const androidSteps = [
    {
      label: 'Open Chrome',
      description: 'Search for "mattool.in" in your Chrome browser',
      image: 'searchgoogle.jpg'
    },
    {
      label: 'Tap menu',
      description: 'Tap the 3 dots in the top right corner',
      image: 'clickon3buttnEDIT.jpg'
    },
    {
      label: 'Add to home screen',
      description: 'Select "Add to Home Screen" or "Install app"',
      image: 'installappandroid1.jpg'
    }
  ];

  const iosSteps = [
    {
      label: 'Open Safari',
      description: 'Search for "mattool.in" in Safari browser',
      image: 'search ios.jpg'
    },
    {
      label: 'Tap Share',
      description: 'Tap the Share button at the bottom of screen',
      image: 'clickonshareiosarrow.jpg'
    },
    {
      label: 'Find Home Screen option',
      description: 'Scroll and tap "Add to Home Screen"',
      image: 'add to homescreeniosarrow.jpg'
    },
    {
      label: 'Confirm',
      description: 'Tap "Add" in the top right corner',
      image: 'now addiosarrow.jpg'
    }
  ];

  const stepStyle = {
    '& .MuiStepLabel-iconContainer': {
      paddingRight: 1
    },
    '& .MuiStepIcon-root': {
      color: '#3d6e75',
      width: 32,
      height: 32
    },
    '& .MuiStepIcon-text': {
      fill: 'white',
      fontWeight: 'bold'
    }
  };
    
    return (
    <Box sx={{ px: 2, py: 2, maxWidth: '100%', overflowX: 'hidden' }}>
      {isandroid && (
        <Box sx={{ 
          border: '1px solid rgba(0,0,0,0.08)', 
          borderRadius: 2, 
          mb: 2, 
          p: 2, 
          backgroundColor: 'rgba(61, 110, 117, 0.04)' 
        }}>
          <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 500 }}>
            Follow these steps to install mattool.in on your Android phone:
          </Typography>
          
          <Box sx={{ mt: 1 }}>
            {androidSteps.map((step, index) => (
              <Box key={index} sx={{ mb: index < androidSteps.length - 1 ? 4 : 1 }}>
                {/* Step header with number */}
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
                  <Box sx={{ 
                    width: 36, 
                    height: 36, 
                    borderRadius: '50%', 
                    bgcolor: '#3d6e75', 
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: 'bold',
                    mr: 2
                  }}>
                    {index + 1}
                  </Box>
                  <Typography variant="subtitle1" fontWeight="500" sx={{ color: '#3d6e75' }}>
                    {step.label}
                  </Typography>
                </Box>
                
                {/* Step content */}
                <Box sx={{ pl: 7 }}>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    {step.description}
                  </Typography>
                  
                  <Paper 
                    elevation={0} 
                    sx={{ 
                      border: '1px solid rgba(0,0,0,0.1)', 
                      borderRadius: 2,
                      overflow: 'hidden',
                      maxWidth: '100%'
                    }}
                  >
                    <Box sx={{ 
                      width: '100%', 
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      py: 1
                    }}>
                      <img 
                        src={step.image} 
                        alt={step.label} 
                        style={{ 
                          maxWidth: '100%',
                          height: 'auto',
                          maxHeight: '180px',
                          objectFit: 'contain'
                        }} 
                      />
                    </Box>
                  </Paper>
                </Box>
                
                {/* Connector line */}
                {index < androidSteps.length - 1 && (
                  <Box 
                    sx={{ 
                      height: 24, 
                      borderLeft: '2px solid rgba(61, 110, 117, 0.38)', 
                      ml: 2.25,
                      mt: 1 
                    }} 
                  />
                )}
              </Box>
            ))}
          </Box>
        </Box>
      )}

      {isios && (
        <Box sx={{ 
          border: '1px solid rgba(0,0,0,0.08)', 
          borderRadius: 2, 
          mb: 2, 
          p: 2, 
          backgroundColor: 'rgba(61, 110, 117, 0.04)' 
        }}>
          <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 500 }}>
            Follow these steps to install mattool.in on your iPhone:
          </Typography>
          
          <Box sx={{ mt: 1 }}>
            {iosSteps.map((step, index) => (
              <Box key={index} sx={{ mb: index < iosSteps.length - 1 ? 4 : 1 }}>
                {/* Step header with number */}
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
                  <Box sx={{ 
                    width: 36, 
                    height: 36, 
                    borderRadius: '50%', 
                    bgcolor: '#3d6e75', 
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: 'bold',
                    mr: 2
                  }}>
                    {index + 1}
                  </Box>
                  <Typography variant="subtitle1" fontWeight="500" sx={{ color: '#3d6e75' }}>
                    {step.label}
                  </Typography>
                </Box>
                
                {/* Step content */}
                <Box sx={{ pl: 7 }}>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    {step.description}
                  </Typography>
                  
                  <Paper 
                    elevation={0} 
                    sx={{ 
                      border: '1px solid rgba(0,0,0,0.1)', 
                      borderRadius: 2,
                      overflow: 'hidden',
                      maxWidth: '100%'
                    }}
                  >
                    <Box sx={{ 
                      width: '100%', 
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      py: 1
                    }}>
                      <img 
                        src={step.image} 
                        alt={step.label} 
                        style={{ 
                          maxWidth: '100%',
                          height: 'auto',
                          maxHeight: '180px',
                          objectFit: 'contain'
                        }} 
                      />
                    </Box>
                  </Paper>
                </Box>
                
                {/* Connector line */}
                {index < iosSteps.length - 1 && (
                  <Box 
                    sx={{ 
                      height: 24, 
                      borderLeft: '2px solid rgba(61, 110, 117, 0.38)', 
                      ml: 2.25,
                      mt: 1 
                    }} 
                  />
                )}
              </Box>
            ))}
          </Box>
        </Box>
      )}
    </Box>
  );
}



